import { render } from "./ImpotentsPage.vue?vue&type=template&id=714826e2"
import script from "./ImpotentsPage.vue?vue&type=script&lang=js"
export * from "./ImpotentsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__